<template>
    <div>
        <myPage :max_flag="true">
            <div class="flex-box nopadding wrap pd-left5 pd-bottom5" slot="header">
                <el-button-group class="mg-right5 mg-top5 flex-box nopadding">
                    <el-button type="primary" size="small" @click="openAddDep" :title="$t('add')" icon="el-icon-edit"></el-button>
                    <el-button size="small" :title="$t('refs')" icon="el-icon-refresh" @click="list()"></el-button>
                    <el-button size="small" @click="exportExcel" :title="$t('export')" icon="el-icon-download"></el-button>
                </el-button-group>
            </div>
            <div class="fillw fillh">
                <div class="tree-box fillh" style="overflow-y: auto">
                    <div v-if="listData.length > 0">
                        <div v-for="item in listData" :key="item.dep_id">
                            <div class="flex-box pd-5">
                                <Icon class="mg-right5" type="ios-arrow-down" />{{item.dep_cname}}
                                <div class="flex-box-bd"></div>
                                <el-button class="round-5 mg-right5" type="primary" size="mini" @click="openAddUser(item.dep_id,item.dep_cname)">{{$t("insert_user")}}</el-button>
                                <el-button class="round-5 mg-right5" type="warning" size="mini" @click="openSave(item.dep_id)">{{$t("info")}}</el-button>
                                <el-button class="round-5" type="danger" size="mini" @click="delDep(item.dep_id)">{{$t("del")}}</el-button>
                            </div>
                            <div class="sub-tree c1" v-for="item2 in item.users" :key="item2.u_id">
                                <span><Icon class="mg-right5 f-green2" type="md-contact" />{{item2.user_cname}}
                                    <span class="user-code-font">({{item2.user_code}})</span>
                                    <a class="f-red" @click="removeUser(item.dep_id, item2.u_id)"><Icon size="24" type="md-backspace" /></a>
                                </span>
                                <div class="sub-tree c2" v-for="item3 in item2.roles" :key="item3.role_id">
                                    <span><Icon class="mg-right5 f-yellow" type="ios-ribbon" />{{item3.role_cname}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <myNodata></myNodata>
                    </div>
                </div>
            </div>
        </myPage>
        <myDrawer v-model="show_subview">
            <router-view></router-view>
        </myDrawer>
    </div>
</template>

<script>
import myNodata from '../../../components/myNodata'
export default {
    name:"org-dep",
    components:{
        myNodata,
    },
    data:function(){
        const listHeader = {
            dep_cname:'部门'
        }
        const listHeader2 = {
            user_cname:'员工'
        }
        return{
            show_subview:false,
            relist:false,
            search:{
                search_url:'dep/list'
            },
            listData: [],
            listHeader,
            listHeader2
        }
    },
    activated:function(){
        this.$base.setMenuOpens();
    },
    mounted: function(){
        this.$base.setMenuOpens();
        this.$base.listPageInit(this,()=>{
            this.list();
        });
    },
    methods:{
        list: function () {
            this.$base.showLoading();
            this.$request.sendPost(this.search.search_url,this.search,(success,data,error)=>{
                this.$base.hideLoading();
                if(success){
                    this.listData = data;
                }
                else{
                    this.$base.alertErr(error.errmsg);
                }
            });
        },
        exportExcel:function() {
            this.$base.exportExcelL3(this,'users')
        },
        openAddDep:function () {
            this.$base.linkTo("/org/dep/save",{op:'add'});
        },
        openAddUser:function (id,dep_cname) {
            this.$base.linkTo("/org/dep/user",{id, dep_cname});
        },
        openSave:function (id) {
            this.$base.linkTo("/org/dep/save",{op:'upd', id});
        },
        delDep: function (dep_id) {
            let data = {
                dep_id: dep_id
            };

            let content = this.$t('chk_del_dep');
            this.$base.confirm(content, () => {
                this.$base.showLoading();
                this.$request.sendPost("dep/del",data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.$base.msgSuccess(error.errmsg);
                        this.list();
                    }
                    else{
                        this.$base.msgErr(error.errmsg);
                    }
                });
            });
        },
        removeUser: function (dep_id, u_id) {
            let data = {
                u_id: u_id,
                dep_id: dep_id
            };
            let content = this.$t('chk_del_user');
            this.$base.confirm(content, () => {
                this.$base.showLoading();
                this.$request.sendPost("dep/del-user",data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.list();
                    }
                    else{
                        this.$base.msgErr(error.errmsg);
                    }
                });
            });
        },
    },
    watch:{
        //界面重新加载数据
        relist:function (newVal,oldVal) {
            if(newVal){
                this.list(true);
                this.relist = false;
            }
        }
    }
}
</script>

<style scoped>
.tree-box{
    max-width: 600px;
}
</style>



// WEBPACK FOOTER //
// src/pages/org/dep/dep.vue